import _PrintRWrapper from 'components/PrintR/_PrintRWrapper'
import { SHOW_DEBUG } from 'constants/DEBUG'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { JSONTree } from 'react-json-tree'
import { withTranslation } from 'react-i18next'

@withTranslation()
export default class PrintR extends Component {
  state = {
    hidden: true
  }

  render () {
    const {
      props: {
        t,
        spoiler,
        title: title_prop,
        css,
        object,
        log_in_console,
        show_on_production
      },
      state: {
        hidden
      },
      showMe,
      hideMe,
    } = this
    const title = title_prop ?? t('Object output')

    if (!SHOW_DEBUG && !show_on_production) return false

    if (spoiler && hidden) {
      return (
        <button
          type={'button'}
          style={{
            position: 'absolute',
            transform: 'translateY(-100%) scale(.8'
          }}
          onClick={showMe}
        >
          {title} ↓
        </button>
      )
    }

    if (log_in_console) {
      console.groupCollapsed('PrintR ' + title)

      console.log('%c PrintR →→→→ ', 'color: green', this.props, '← this.props | ')
      console.trace()

      console.groupEnd()
    }

    return (
      <_PrintRWrapper {...{css}}>
        <h2 className='title'>{title} {(spoiler && !hidden) &&
        <button type={'button'} onClick={hideMe}>
          {t('hide ↑')}
        </button>
        }
        </h2>
        {typeof object === 'undefined'
         ? <div className='error'>{t('Empty...')}</div>
         : (
           <JSONTree invertTheme={false} data={object} />
         )
        }
      </_PrintRWrapper>)
  }

  hideMe = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          hidden: true
        }
      }
    )
  }

  showMe = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          hidden: false
        }
      }
    )
  }

  static defaultProps = {
    title: null,
    log_in_console: true
  }

  static propTypes = {
    /**
     * Обязательный аттрибут. В него помещается объект для рекурсивного вывода на экран
     */
    object: PropTypes.any.isRequired,

    /**
     * Заголовок
     */
    title: PropTypes.node,

    /**
     * Дублирует вывод в консоль
     */
    log_in_console: PropTypes.bool,

    /**
     * Прячет вывод в спойлер
     */
    spoiler: PropTypes.bool,

    /**
     * Выводит сообщения в том числе на продакшене
     */
    show_on_production: PropTypes.bool,
  }

}
